import { GenIcon } from '../helpers/IconBase.es.js';

const PbNavigationRoundFilled = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "rect",
        attr: { width: "24", height: "24", rx: "12", fill: "#4D4D4D" }
      },
      {
        tag: "path",
        attr: {
          d: "M14.3335 7.3335L9.66683 12.0002L14.3335 16.6668",
          stroke: "#7D7D7D",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      }
    ]
  })(props);
};

export { PbNavigationRoundFilled };
